document.addEventListener("scroll", () => {
  const scrollBtn = document.querySelector(".scroll-progress");
  if (!scrollBtn) return;

  const scrollTop = window.scrollY;
  const docHeight =
    document.documentElement.scrollHeight - window.innerHeight;

  const scrollPercent = (scrollTop / docHeight) * 100;

  scrollBtn.style.setProperty("--progress", `${scrollPercent}%`);
});
